import { Box } from "@mui/material";
import React, { useState } from "react";
import img from "./miniorange-logo.png";
import bg from "./register-img.jpg";
import GoogleLogo from "./google-svg";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";

function Register() {
  const navigate = useNavigate();
  const [loadingScreenTime, setLoadingScreenTime] = useState(false);
  const [formValues, setFormValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmpassword: "",
    phoneno: "",
    usecase: "",
  });
  const [passwordError, setPasswordError] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;

    if (name === "confirmpassword") {
      if (formValues.password !== value) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }
    } else if (name === "password") {
      if (
        formValues.confirmpassword === value ||
        formValues.confirmpassword === ""
      ) {
        setPasswordError(false);
      } else {
        setPasswordError(true);
      }
    }
    setFormValues((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const handleSubmit = (event) => {
    var source = window.location.href.split('source=')[1]
    event.preventDefault();
    if (formValues.confirmpassword !== formValues.password) {
      return;
    }
    // setLoadingScreenTime(true);
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/register`, {
        username: formValues.username,
        email: formValues.email,
        password: formValues.password,
        confirmpassword: formValues.confirmpassword,
        phoneno: formValues.phoneno,
        // areaofinterest: areaofinterest,
        usecase: formValues.usecase,
        referrer: source
      })
      .then((res) => {
        // setLoadingScreenTime(false);
        swal({
          text: res.data.title,
          icon: "success",
          // type: "success",
        });
        navigate("/");
      })
      .catch((err) => {
        // setLoadingScreenTime(false);
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
          //type: "error",
        });
      });
  };

  async function googleSignIn() {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/google-sign-in-redirect-url`)
      .then((response) => {
        if (response.data.status) {
          window.location.href = response.data.url;
        }
      })
      .catch((err) => {
        console.log(err);
        swal({
          text: "Something Went Wrong",
          icon: "error",
        });
      });
  }

  return (
    <>
      <Box
        sx={{
          display: "block",
          overflowX: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Box
            sx={{
              width: "456px",
              height: "100vh",
              backgroundImage: "url(" + bg + ")",
              objectFit: "contain",
              backgroundSize: "cover",
              position: "fixed",
              display: "block",
            }}
          ></Box>
          <Box
            sx={{
              width: "1086px",
              margin: "50px 0px 50px 42px",
              paddingLeft: "450px",
            }}
          >
            <img src={img} style={{ width: "250px", marginLeft: "-11px" }} />
            <h2 className="login-text">Create your account</h2>
            <span className="login-subtitle">
              Have an account?
              <a
                style={{ textDecoration: "none", color: "rgb(1, 107, 248)" }}
                href="/"
              >
                &nbsp;Sign in
              </a>
            </span>
            <button
              onClick={googleSignIn}
              type="button"
              className="login-with-google-btn"
            >
              <GoogleLogo />
              <span className="google-text">Google</span>
            </button>
            <div className="or-box">
              <span className="or-text">Or with email and password</span>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="input-row">
                <fieldset className="login-form">
                  <label
                    htmlFor="email"
                    id="emailLabel"
                    className="login-form-label"
                  >
                    Email address
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="email"
                          aria-labelledby="emailLabel"
                          type="email"
                          className="input-custom-css"
                          id="email"
                          aria-invalid="false"
                          value={formValues.email}
                          onChange={onChange}
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <fieldset className="login-form">
                  <label
                    htmlFor="username"
                    id="usernameLabel"
                    className="login-form-label"
                  >
                    Username
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="username"
                          aria-labelledby="usernameLabel"
                          type="text"
                          className="input-custom-css"
                          id="username"
                          aria-invalid="false"
                          value={formValues.username}
                          onChange={onChange}
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
              </div>
              <div className="input-row">
                <fieldset className="login-form">
                  <label
                    htmlFor="password"
                    id="passwordLabel"
                    className="login-form-label"
                  >
                    Password
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="password"
                          aria-labelledby="passwordLabel"
                          type="password"
                          className="input-custom-css"
                          id="password"
                          aria-invalid="false"
                          value={formValues.password}
                          onChange={onChange}
                          minLength="8"
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <fieldset className="login-form">
                  <label
                    htmlFor="confirmpassword"
                    id="confirmpasswordLabel"
                    className="login-form-label"
                  >
                    Confirm Password
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="confirmpassword"
                          aria-labelledby="confirmpasswordLabel"
                          type="password"
                          className="input-custom-css"
                          id="confirmpassword"
                          aria-invalid="false"
                          value={formValues.confirmpassword}
                          onChange={onChange}
                          minlength="8"
                        ></input>
                      </div>
                    </div>
                  </label>
                  {passwordError && (
                    <span className="error-message">
                      Please provide password
                    </span>
                  )}
                </fieldset>
              </div>
              <div className="input-row">
                <fieldset className="login-form">
                  <label
                    htmlFor="phoneno"
                    id="phonenoLabel"
                    className="login-form-label"
                  >
                    Phone Number
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <input
                          required
                          name="phoneno"
                          aria-labelledby="phonenoLabel"
                          type="tel"
                          className="input-custom-css"
                          id="phoneno"
                          aria-invalid="false"
                          value={formValues.phoneno}
                          onChange={onChange}
                        ></input>
                      </div>
                    </div>
                  </label>
                </fieldset>
                <fieldset className="login-form">
                  <label
                    htmlFor="usecase"
                    id="usecaseLabel"
                    className="login-form-label"
                  >
                    Use Case
                    <div className="input-div-css-1  input-div-css-2">
                      <div className="input-div-css-3">
                        <select
                          required
                          className="input-custom-css select-input"
                          id="usecase"
                          aria-labelledby="usecaseLabel"
                          name="usecase"
                          value={formValues.usecase}
                          onChange={onChange}
                          aria-invalid="false"
                          defaultValue={""}
                        >
                          <option selected disabled value="">
                            Select Use Case
                          </option>

                          <option value="NFT Token Gating">
                            NFT Token Gating
                          </option>
                          <option value="Google Drive NFT Token Gating">
                            Google Drive Token Gating
                          </option>
                          <option value="Discord NFT Token Gating">
                            Discord Token Gating
                          </option>
                        </select>
                      </div>
                    </div>
                  </label>
                </fieldset>
              </div>

              <div className="register-button-div">
                <button type="submit" className="custom-button">
                  Register
                </button>
              </div>
            </form>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Register;
